import { ClientError } from '@common/helpers/errors';

// The jobs.actions.update BFF procedure was decommissioned along with
// je-client / je-job-service. This hook is retained as an inert stub so
// obsolete job-edit UI still compiles; updating a job is no longer wired to a
// backend.
export type UpdateJobParams = any;

export const useUpdateJob = () => {
  const mutateAsync = (_params?: UpdateJobParams): Promise<any> =>
    Promise.resolve(undefined);
  const isSuccess = false;
  const error = null as any;

  return {
    updateJobData: mutateAsync,
    isSuccess,
    error: getClientError(error)
  };
};

const getClientError = (error) => {
  if (!error?.message) return;

  return new ClientError('errors.defaultWithGuid', {
    guid: error?.properties?.guid,
    responseBody: error?.properties?.errorMessage
  });
};
